export const phoneRegex = /^[0-9]{10}$/;
export const OtherCountriesPincodeRegex = /^[0-9a-zA-Z]+$/;
export const IndianPassportRegex = /^[A-Z]{1}[0-9]{7}$|^[A-Z]{2}[0-9]{6}$/;
export const NonIndianPassportRegex = /^[A-Za-z0-9_@./#&+-]*$/;
export const alphaNumericRegex = /^[a-zA-Z0-9]+$/;
export const alphabetRegex = /^[a-zA-Z\s]+$/;
export const linkRegex = /^(https?:\/\/[^\s]+)$/;
export const mobileRegEx = /^[0-9]{10}$/;
